import * as types from '../actions/actionTypes';
import initialState from './initialState';


export default function locationReducer(state = initialState.location, action){
  switch(action.type) {
    case types.DEVICE_LOCATION_SUCCESS:
       return {...action.deviceLocation};
    default:
          return state;
  }
}
